import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "clipboard" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M17.625 4.5H14.5C14.5 3.12109 13.3789 2 12 2C10.6211 2 9.5 3.12109 9.5 4.5H6.375C5.33984 4.5 4.5 5.33984 4.5 6.375V20.125C4.5 21.1602 5.33984 22 6.375 22H17.625C18.6602 22 19.5 21.1602 19.5 20.125V6.375C19.5 5.33984 18.6602 4.5 17.625 4.5ZM12 3.5625C12.5195 3.5625 12.9375 3.98047 12.9375 4.5C12.9375 5.01953 12.5195 5.4375 12 5.4375C11.4805 5.4375 11.0625 5.01953 11.0625 4.5C11.0625 3.98047 11.4805 3.5625 12 3.5625ZM17.625 19.8906C17.625 20.0195 17.5195 20.125 17.3906 20.125H6.60938C6.48047 20.125 6.375 20.0195 6.375 19.8906V6.60938C6.375 6.48047 6.48047 6.375 6.60938 6.375H8.25V7.78125C8.25 8.03906 8.46094 8.25 8.71875 8.25H15.2812C15.5391 8.25 15.75 8.03906 15.75 7.78125V6.375H17.3906C17.5195 6.375 17.625 6.48047 17.625 6.60938V19.8906Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }